let poly = require("preact-cli/lib/lib/webpack/polyfills")

import { client } from "./modules/apollo"
import { ApolloProvider } from "@apollo/react-hooks"

import habitat from "preact-habitat"

import Widgets from "./components/widgets/renderer"

let _habitat = habitat(props => {
  return (
    <ApolloProvider client={client}>
      <Widgets {...props}></Widgets>
    </ApolloProvider>
  )
})

//Function to check if widget is loaded in iframe
window.isIframe = function() {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

const render = () => {
  _habitat.render({
    selector: '[data-widget-host="newsnerwidgets-container"]',
    clean: true,
  })
}
render()

window.rerender_widgets = function() {
  render()
}
